import { roundDownToNearestTen } from '../../common/helpers/round-helpers'
import { SET_INITIAL_OFFER, OfferActions, USER_CHANGE_CURRENT_LOAN_AMOUNT, CHANGE_CURRENT_INSTALLMENT_NUMBER, RECALCULATE_OFFER, SET_MAX_LOAN_AMOUNT_FOR_MIN_INSTALLMENT, SET_CURRENT_CUSTOM_CLIENT_OFFER, SET_PREDEFINED_USER_OFFERS_ARRAY, SET_CURRENT_USER_OFFER_PARAMS, SET_PREDEFINED_USER_OFFERS_OBJECT } from "../actions/offert-action";
import { IOfferState } from "../types";

export const offertInitialState: IOfferState = {
   requestedAmount: 0, //Kwota pożyczki
   instalments: undefined, //Okres spłaty
   instalmentAmount: undefined, //Kwota raty
   maxInstallmentNumber: 0, //Maksymalny okres pożyczki
   minInstallmentNumber: 0, //Minimalny okres pożyczki
   ckdz: 0, //Całkowita kwota do spłaty
   interestRate: 0, //Oprocentowanie
   rrso: 0, // RRSO
   offerId: undefined, //Id obecnie prezentowanej oferty z bazy danych
   isOk: true, //Flaga - czy oferta przeliczyła się poprawnie
   paymentDate: undefined, //Data spłaty pierwszej raty
   
   minimumLoanAmount: 0, //Minimalna kwota pożyczki
   currentMaximumLoanAmount: 1, //Maksymalna kwota pożyczki dla obecnie wybranej ilości rat
   currentSelectedInstallmentNumber: 0, //Obecnie wybrany okres spłaty - TĄ WARTOŚĆ UŻYWAMY I PREZENTUJEMY
   maximumLoanAmount_minimumInstallment: 0, //Maksymalna kwota pożyczki dla minimalnej ilości rat 
   maximumLoanAmount_maximumInstallment:  1, //Maksymalna kwota pożyczki dla maksymalnej ilości rat
   
   hasUserChangeAmount: false, //Informacja czy uzytkownik dokonał zmiany kwoty (poprzez kontrolkę lub slider)
   currentCustomClientOffer: null,

   predefinedUserOffersArray: undefined, //Tablica z predefiniowanymi ofertami dla użytkownika
   predefinedUserOffersObject: undefined, // [ZAŁOŻENIE BIZNESOWE] Obiekt z predefiniowanymi ofertami dla użytkownika, używany mechanizmie PREDEFINIOWANYCH OKRESÓW POŻYCZKI 
   noOfRecalculation: 0
};

export function offerReducer(state: IOfferState = offertInitialState, action: OfferActions) {
  switch (action.type) {
    
    case SET_INITIAL_OFFER: {
      const currentMaximumLoanAmount = roundDownToNearestTen(action.payload.currentMaximumLoanAmount)
      return {
         //Jako inicjalną kwotę ustawiamy najwyższą dostępną dla użytkownika
         requestedAmount: currentMaximumLoanAmount,

         instalments: action.payload?.instalments,
         instalmentAmount: action.payload?.instalmentAmount,
         currentMaximumLoanAmount: currentMaximumLoanAmount,
         minimumLoanAmount:  action.payload.minimumLoanAmount, 
         maxInstallmentNumber: action.payload.maxInstallmentNumber,
         minInstallmentNumber: action.payload.minInstallmentNumber,
         ckdz: action.payload?.ckdz,
         interestRate: action.payload?.interestRate,
         rrso: action.payload?.rrso,
         offerId: action.payload.offerId,
         isOk: action.payload.isOk,
         paymentDate: action.payload?.paymentDate,

         currentSelectedInstallmentNumber: action.payload.currentSelectedInstallmentNumber,
         maximumLoanAmount_minimumInstallment: action.payload.maximumLoanAmount_minimumInstallment,
         maximumLoanAmount_maximumInstallment: action.payload.maximumLoanAmount_maximumInstallment,

         hasUserChangeAmount: false, //Przy pierwszym wejściu na stronę użytkownik jeszcze niczego nie zmienił
         currentCustomClientOffer: action.payload.currentCustomClientOffer,
         isCustomOfferOnly: action.payload.isCustomOfferOnly ?? false,
         noOfRecalculation:  0

      };
    }
    case USER_CHANGE_CURRENT_LOAN_AMOUNT: {
      return {
         ...state,
         requestedAmount: action.payload,
         hasUserChangeAmount: true, //Użytkownik dokonał zmiany kwoty pożyczki
      }
    }
    case SET_CURRENT_USER_OFFER_PARAMS: {
      return {
        ...state,
        requestedAmount: action.payload.requestedAmount,
        instalments: action.payload.instalments,
        instalmentAmount: action.payload.instalmentsAmount
      }
    }
    case CHANGE_CURRENT_INSTALLMENT_NUMBER: {

      if(action.payload >= state.minInstallmentNumber && action.payload <= state.maxInstallmentNumber){ // Sprawdzenie, czy nowa wartość mieści się w zakresie oferty
        return {
          ...state,
          currentSelectedInstallmentNumber: action.payload,
        }
      }

      else return {...state}

    }
    case RECALCULATE_OFFER: {

      const { payload } = action
      let currentMaximumLoanAmountBasedOnCurrentInstallment = state.maximumLoanAmount_maximumInstallment
      let hasUserChangeAmount = state.hasUserChangeAmount

      if(!payload.isOk){
        return {
          ...state,
          isOk: payload.isOk
        }
      }
      
      //Jeśli wybraliśmy mniejszą liczbę rat zmieniamy maksymalną kwotę pożyczki na wcześniej przeliczoną wartość
      if(state.currentSelectedInstallmentNumber === state.minInstallmentNumber){ 
        currentMaximumLoanAmountBasedOnCurrentInstallment = state.maximumLoanAmount_minimumInstallment ?? state.maximumLoanAmount_maximumInstallment
      }
      
      // Sytuacja gdy wnioskowana kwota pożyczki jest większa od aktualnego maksimum
      if(payload.requestedAmount && payload.requestedAmount > currentMaximumLoanAmountBasedOnCurrentInstallment){
        payload.requestedAmount = currentMaximumLoanAmountBasedOnCurrentInstallment
      }

      //Jeśli użytkownik nie dokonał żadnej zmiany w kwocie pożyczki, prezentujemy zawsze maksimum dla danego okresu
      if(!hasUserChangeAmount){
        payload.requestedAmount = currentMaximumLoanAmountBasedOnCurrentInstallment
      }

      return {
        ...state,
        requestedAmount: payload.requestedAmount ?? state.requestedAmount,
        instalments: payload.instalments ?? state.instalments,
        instalmentAmount: payload.instalmentsAmount ?? state.instalmentAmount,
        ckdz: payload.ckdz ?? state.ckdz,
        interestRate: payload.interestRate ?? state.interestRate,
        rrso: payload.rrso ?? state.rrso,
        offerId: payload.offerId ?? state.offerId,
        currentMaximumLoanAmount: currentMaximumLoanAmountBasedOnCurrentInstallment,
        paymentDate: payload.paymentDate ?? state.paymentDate,

        isOk: payload.isOk ?? state.isOk,
        noOfRecalculation: state.noOfRecalculation ?  state.noOfRecalculation + 1 : 1
      }
    }
    case SET_MAX_LOAN_AMOUNT_FOR_MIN_INSTALLMENT: {
      return {
        ...state,
        maximumLoanAmount_minimumInstallment: action.payload,
      }
    }
    case SET_CURRENT_CUSTOM_CLIENT_OFFER: {
      return {
        ...state,
        currentCustomClientOffer: action.payload,
      }
    }
    case SET_PREDEFINED_USER_OFFERS_ARRAY: {
      return {
        ...state,
        predefinedUserOffersArray: action.payload,
      }
    }
    case SET_PREDEFINED_USER_OFFERS_OBJECT: {
      return {
        ...state,
        predefinedUserOffersObject: action.payload,
      }
    }
    default:{
      return state;
    }
  }
}
